import Linkify from './Linkify';

export default Linkify;
